document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function() {
        // Load Cookiebot script
        var cookiebotScript = document.createElement('script');
        cookiebotScript.id = 'Cookiebot';
        cookiebotScript.src = 'https://consent.cookiebot.com/uc.js';
        cookiebotScript.setAttribute('data-cbid', 'e9531095-6c2b-4d3a-bd3c-b40ee854fad9');
        cookiebotScript.type = 'text/javascript';
        cookiebotScript.async = true;
        document.head.appendChild(cookiebotScript);

        // Load Refersion script
        var refersionScript = document.createElement('script');
        refersionScript.async = true;
        refersionScript.src = 'https://cdn.refersion.com/refersion.js';
        refersionScript.onload = function() {
            var r = window.r || {};
            r.pubKey = 'pub_b2fb4ae8707d7aa5985e';
            r.settings = { fp_off: true };

            r.initializeXDLS().then(() => {
                r.launchDefault();
            });

            document.addEventListener('instantAddToCart', function() {
                setTimeout(() => {
                    trackEvent();
                }, 1000);
            });

            document.addEventListener('instantCheckout', function(e) {
                e.preventDefault();
                trackEvent();
                window.location.href = e.detail.checkoutUrl;
            });

            function trackEvent() {
                try {
                    let shoppifyUrl = new URL(window.Instant.cart.externalId);
                    shoppifyUrl.searchParams.delete("key");
                    let token = shoppifyUrl.toString().split("/").pop();
                    let id = localStorage.getItem("rfsn_v4_id");
                    let url = window.location.href;
                    let aid = localStorage.getItem("rfsn_v4_aid");
                    let cs = localStorage.getItem("rfsn_v4_cs");
                    r.sendCheckoutEvent(token, id, url, aid, cs);
                } catch (e) {}
            }
        };
        document.head.appendChild(refersionScript);

        // Load Hotjar script
        (function(h, o, t, j, a, r) {
            h.hj = h.hj || function() { (h.hj.q = h.hj.q || []).push(arguments) };
            h._hjSettings = { hjid: 5083762, hjsv: 6 };
            a = o.getElementsByTagName('head')[0];
            r = o.createElement('script'); 
            r.async = 1;
            r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
            a.appendChild(r);
        })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');

        
    }, 3000);
});
